<template>
  <div class="flex-column d-flex">
    <v-card rounded="0" width="100%" elevation="0" class="quiz-card">
      <Typography as="p" variant="h-5" class="quiz-question__title mb-0">
        {{ question.content }}{{ !isRequired ? " (optional)" : "" }}
      </Typography>
      <Typography as="p" variant="body-2" class="pt-5 quiz-question__helper mb-0">
        Choose a response on the slider below
      </Typography>
      <v-divider class="mt-5" />
      <div class="d-flex flex-column align-center text-center my-4 mx-10">
        <span class="quiz-question__slider-value">{{ sliderValue }}</span>
        <v-slider
          v-model="sliderValue"
          class="slider"
          color="brandPrimary"
          :min="this.question.lowerBound"
          :max="this.question.upperBound"
          ticks
          :disabled="answered"
        >
        </v-slider>
      </div>
      <div
        v-if="answered == true && correctAnswer && !isSurveyQuestion"
        class="answer-box d-flex justify-center align-center cursor-pointer mb-6 mx-auto"
        :class="{
          'brand-pale-green-background':
            answered &&
            ((correctAnswer && correctAnswer.content == sliderValue) || noCorrectAnswersMarked),
          'light-red-background':
            answered &&
            !noCorrectAnswersMarked &&
            correctAnswer &&
            correctAnswer.content != sliderValue,
        }"
      >
        <!-- -->
        <div class="d-flex justify-center">
          <v-icon
            color="brandGreen"
            class="answer-icon"
            v-if="answered && correctAnswer && correctAnswer.content == sliderValue"
            >mdi-check-circle</v-icon
          >
          <v-icon color="red" class="answer-icon" v-else>mdi-close</v-icon>
          <span class="ml-2">{{ correctAnswer.content }}</span>
        </div>
      </div>

      <v-divider />

      <div class="d-flex justify-center mt-10">
        <v-btn
          :color="!inProgram ? 'brandPrimary' : 'brand'"
          :rounded="!inProgram"
          class="white--text"
          width="120"
          depressed
          :loading="postingResponse"
          :disabled="isMissingRequiredValue(sliderValue)"
          @click="checkQuestion"
          v-if="answered == false"
        >
          {{ computedSubmitButton }}
        </v-btn>

        <v-btn
          :color="!inProgram ? 'brandPrimary' : 'brand'"
          :rounded="!inProgram"
          class="white--text"
          width="120"
          depressed
          @click="goToNextQuestion"
          v-else-if="!isLastQuestion && answered == true"
        >
          Next
        </v-btn>

        <v-btn
          :color="!inProgram ? 'brandPrimary' : 'brand'"
          :rounded="!inProgram"
          class="white--text"
          width="120"
          depressed
          @click="completeQuiz"
          v-else-if="isLastQuestion && answered == true && !isSurveyQuestion"
        >
          Complete
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import quizQuestionResponseMixin from "@/components/learning/QuizQuestion/mixins/quizQuestionResponseMixin";

export default {
  name: "QuizQuestionScaleV2",
  mixins: [quizQuestionResponseMixin],
  components: { Typography },
  data() {
    return {
      sliderValue: null,
      correctCount: 0,
      answered: false,
    };
  },
  methods: {
    checkQuestion() {
      if (
        this.skipOptionalUnanswered(this.sliderValue, {
          onSuccess: () => {
            this.correctCount++;
            this.handleSuccess();
          },
        })
      ) {
        return;
      }

      var answerId = null;
      if (
        (this.correctAnswer && this.correctAnswer.content == this.sliderValue) ||
        !this.correctAnswer ||
        !this.isRequired
      ) {
        if (this.correctAnswer) answerId = this.correctAnswer.learningQuizAnswerId;
        this.correctCount++;
      }

      const quizQuestionResponse = this.buildBaseResponse({
        learningQuizAnswerId: answerId,
        value: this.sliderValue,
        correctness: this.isSurveyQuestion
          ? null
          : answerId != null
          ? 1
          : this.correctAnswer
          ? 0
          : null,
      });

      this.postResponseAndAdvance([quizQuestionResponse], {
        onSuccess: this.handleSuccess,
        onError: this.handleError,
      });
    },
    handleSuccess() {
      this.answered = true;
      if (
        this.isSurveyQuestion ||
        !this.correctAnswer ||
        (!this.isRequired && !this.hasValue(this.sliderValue))
      ) {
        this.goToNextQuestion();
      }
    },
    handleError() {
      this.answered = false;
    },
    goToNextQuestion() {
      if (!this.isLastQuestion) {
        this.answered = false;
        this.sliderValue = null;
        this.$emit("next-question", this.correctCount);
      } else {
        this.completeQuiz();
      }
    },
    completeQuiz() {
      this.$emit("complete-quiz", this.correctCount);
    },
  },
  computed: {
    correctAnswer() {
      if (!this.question) return null;
      let correct = this.question.LearningQuizAnswers.filter(
        (ans) => ans.correctness > 0 && ans.status == "Active"
      );
      if (correct.length) return correct[0];
      return null;
    },
  },
};
</script>

<style scoped>
.brand-pale-green-background {
  background-color: var(--v-brandPaleGreen-base);
}
.light-red-background {
  background-color: #fcdeda;
}

.slider {
  width: 100%;
}

/* Figma: question = Headline/h5, helper = Body/Body 2, value = Body/Body 1 */
.quiz-question__title {
  color: rgba(0, 0, 0, 0.87);
  word-break: normal;
}

.quiz-question__helper {
  color: rgba(0, 0, 0, 0.6);
}

.quiz-question__slider-value {
  font-family: "Avenir Book", Helvetica, Arial, sans-serif !important;
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(0, 0, 0, 0.87);
}

/* Container for individual answer box */
.answer-box {
  min-height: 60px;
  height: 60px;
  width: 200px;
  padding: 0 20px 0 20px;
}

.answer-icon {
  transform: scale(1.1);
}
</style>
